module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "integralMallExamine zdy-groupList paddingTop45 commonStyle"
  }, [_c('x-header', {
    staticClass: "intallMallHead"
  }, [_vm._v(_vm._s(_vm.$route.query.title))]), _vm._v(" "), (_vm.$route.query.title == '诊疗服务') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.Examineimg
    }
  }), _vm._v(" "), _vm._m(0, false, false)]) : _vm._e(), _vm._v(" "), (_vm.$route.query.title == '好孕礼包') ? _c('div', [_c('img', {
    attrs: {
      "src": _vm.Examineimg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "color": "#fff",
      "background-image": "linear-gradient(#2790d2, #0061ae)",
      "height": "40px",
      "line-height": "40px",
      "padding": "10px 0",
      "width": "93%",
      "margin": "0 auto",
      "border-radius": "10px",
      "font-size": "20px",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("确认使用")])])]) : _vm._e(), _vm._v(" "), (_vm.$route.query.title == '限时礼包') ? _c('div', {
    class: _vm.contentClass
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "src": _vm.Examineimg
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.employ != '1' && _vm.employ != '2'),
      expression: "employ!='1'&& employ!='2'"
    }]
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("超值大礼包领取须知")]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('p', {
    staticClass: "xtitle"
  }, [_vm._v("1.领取礼包流程")]), _vm._v(" "), _c('p', [_vm._v("积分兑换页面进行兑换 -- 联系工作人员确认领取方式")]), _vm._v(" "), _c('p', {
    staticClass: "xtitle"
  }, [_vm._v("2.领取方式")]), _vm._v(" "), _c('p', [_vm._v("异地邮寄：需提前向工作人员提供详细邮寄地址，邮费到付自理")]), _vm._v(" "), _c('p', [_vm._v("到院现场领取：1F早孕管理中心。(工作时间：8:00-17:30)")]), _vm._v(" "), _c('p', {
    staticClass: "xtitle"
  }, [_vm._v("3.领取时间")]), _vm._v(" "), _c('p', [_vm._v("为兑换后的7个工作日左右")]), _vm._v(" "), _c('p', {
    staticClass: "xtitle"
  }, [_vm._v("4.联系人")]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('p', {
    staticClass: "xtitle"
  }, [_vm._v("*本活动最终解释权归西囡妇科医院所有")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.employ == '1' || _vm.employ == '2'),
      expression: "employ=='1'|| employ=='2'"
    }]
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("超值大礼包领取须知")]), _vm._v(" "), _c('p', [_vm._v("1.领取途径")]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('p', [_vm._v("2.限时领取，发完即止（*此礼包不开具发票）")]), _vm._v(" "), _c('p', [_vm._v("3.礼品一概兑换，不退不换")]), _vm._v(" "), _c('p', [_vm._v("4.如有疑问")]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('p', {
    staticClass: "xtitle"
  }, [_vm._v("*本活动最终解释权归西囡妇科医院所有")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_c('p', [_vm._v("确认兑换")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footerPromt"
  }, [_vm._v("\n          如有疑问，请拨打院内咨询电话："), _c('a', {
    staticStyle: {
      "color": "#005BAB",
      "font-weight": "bold"
    },
    attrs: {
      "href": "tel:02865003333"
    }
  }, [_vm._v("028-65003333")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "smalltitle"
  }, [_vm._v("四川锦欣西囡妇女儿童医院感谢您的好孕传递"), _c('br'), _vm._v("让我们一起帮助更多人实现为人父母的心愿。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("王老师"), _c('a', {
    attrs: {
      "href": "tel:19828919771"
    }
  }, [_vm._v("19828919771")]), _vm._v("，罗老师"), _c('a', {
    attrs: {
      "href": "tel:18782030241"
    }
  }, [_vm._v("18782030241")]), _vm._v("。(工作时间：8:00-17:30)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("兑换后请联系工作人员：伍文怡"), _c('a', {
    attrs: {
      "href": "tel:13880421717"
    }
  }, [_vm._v("13880421717")]), _vm._v("，虞芳"), _c('a', {
    attrs: {
      "href": "tel:18628247030"
    }
  }, [_vm._v("18628247030")]), _vm._v("\n              陈桃梅"), _c('a', {
    attrs: {
      "href": "tel:13540072378"
    }
  }, [_vm._v("13540072378")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("请拨打院内咨询电话：伍文怡"), _c('a', {
    attrs: {
      "href": "tel:13880421717"
    }
  }, [_vm._v("13880421717")]), _vm._v("，虞芳"), _c('a', {
    attrs: {
      "href": "tel:18628247030"
    }
  }, [_vm._v("18628247030")]), _vm._v("陈桃梅"), _c('a', {
    attrs: {
      "href": "tel:13540072378"
    }
  }, [_vm._v("13540072378")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1baf01de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/integralMallProject/integralMallExamine.vue
// module id = mbHC
// module chunks = 6